import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[textareaAutosize]',
    standalone: false
})
export class TextareaAutosizeDirective {
  constructor(private elementRef: ElementRef) {}

  @HostListener('input') onInput(): void {
    this.resizeTextarea();
  }

  private resizeTextarea(): void {
    const textarea = this.elementRef.nativeElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }
}